export const LOCALE_CONSTANTS = {
  STORAGE_KEY: 'tf_locale',
  DEFAULT_LOCALE: 'en',
  COOKIE_NAME: 'googtrans',

  SUPPORTED_LANGUAGES: [
    { code: 'en', name: 'English', englishName: 'English' },
    { code: 'es', name: 'Español', englishName: 'Spanish' },
    { code: 'fr', name: 'Français', englishName: 'French' },
    { code: 'de', name: 'Deutsch', englishName: 'German' },
    { code: 'zh-CN', name: '中文（普通话）', englishName: 'Mandarin Chinese' },
    { code: 'hi', name: 'हिन्दी', englishName: 'Hindi' },
    { code: 'ja', name: '日本語', englishName: 'Japanese' },
    { code: 'ar', name: 'العربية', englishName: 'Modern Standard Arabic' },
    { code: 'ko', name: '한국어', englishName: 'Korean' },
    { code: 'bn', name: 'বাংলা', englishName: 'Bengali' },
    { code: 'pt', name: 'Português', englishName: 'Portuguese' },
    { code: 'ru', name: 'Русский', englishName: 'Russian' },
    { code: 'ur', name: 'اردو', englishName: 'Urdu' },
    { code: 'id', name: 'Bahasa Indonesia', englishName: 'Indonesian' },
    // { code: 'pcm', name: 'Nigerian Pidgin', englishName: 'Nigerian Pidgin' },
    // { code: 'arz', name: 'اللهجة المصرية', englishName: 'Egyptian Arabic' },
    { code: 'mr', name: 'मराठी', englishName: 'Marathi' },
    { code: 'te', name: 'తెలుగు', englishName: 'Telugu' },
    { code: 'tr', name: 'Türkçe', englishName: 'Turkish' },
    { code: 'ta', name: 'தமிழ்', englishName: 'Tamil' },
    { code: 'yue', name: '粵語', englishName: 'Cantonese' },
    { code: 'vi', name: 'Tiếng Việt', englishName: 'Vietnamese' },
    // { code: 'wuu', name: '吴语', englishName: 'Wu Chinese' },
    { code: 'tl', name: 'Tagalog / Filipino', englishName: 'Tagalog / Filipino' },
    { code: 'fa', name: 'فارسی', englishName: 'Persian' },
    { code: 'it', name: 'Italiano', englishName: 'Italian' },
    { code: 'ha', name: 'Hausa', englishName: 'Hausa' },
    { code: 'sw', name: 'Kiswahili', englishName: 'Swahili' },
    { code: 'th', name: 'ไทย', englishName: 'Thai' },
    { code: 'gu', name: 'ગુજરાતી', englishName: 'Gujarati' },
    { code: 'pl', name: 'Polski', englishName: 'Polish' },
    { code: 'ps', name: 'پښتو', englishName: 'Pashto' },
    { code: 'kn', name: 'ಕನ್ನಡ', englishName: 'Kannada' },
    { code: 'ml', name: 'മലയാളം', englishName: 'Malayalam' },
    { code: 'am', name: 'አማርኛ', englishName: 'Amharic' },
    { code: 'or', name: 'ଓଡ଼ିଆ', englishName: 'Odia' },
    { code: 'my', name: 'မြန်မာ', englishName: 'Burmese' },
    { code: 'pa', name: 'پنجابی', englishName: 'Western Punjabi' },
    { code: 'su', name: 'Basa Sunda', englishName: 'Sundanese' },
    { code: 'uk', name: 'Українська', englishName: 'Ukrainian' },
    { code: 'no', name: 'Norsk', englishName: 'Norwegian' },
    { code: 'fi', name: 'Suomi', englishName: 'Finnish' },
    { code: 'el', name: 'Ελληνικά', englishName: 'Greek' },
    { code: 'hu', name: 'Magyar', englishName: 'Hungarian' },
    { code: 'ro', name: 'Română', englishName: 'Romanian' },
    { code: 'iw', name: 'עברית', englishName: 'Hebrew' }
  ],

  LABELS: {
    LANGUAGE: 'Language',
    SELECT_LANGUAGE: 'Select Language',
    SEARCH_LANGUAGE: 'Search language...'
  }
} as const;
